package com.milta.core.localization.translations.nl

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Laden…",
    errorNoConnection = "Kan de server niet bereiken — controleer je verbinding.",
    errorGeneric = "Er is iets misgegaan. Probeer het later opnieuw.",
    contractLockedNotice = "🔒 Het uitvoercontract (JSON-formaat) blijft vergrendeld — het wordt automatisch server-side toegevoegd na de bewerkte tekst, zodat de extractie in productie nooit breekt.",
    notModifiedLabel = "Standaardwaarde — nooit gewijzigd",
    modifiedOnPrefix = "Gewijzigd op",
    resetToDefaultAction = "↺ Terugzetten naar standaardwaarden",
    editableBodyLabel = "✏️ Bewerkbare inhoud — bedrijfsregels",
    markdownBoldSnippet = "**vetgedrukte tekst**",
    markdownItalicSnippet = "*cursieve tekst*",
    markdownCodeSnippet = "`code`",
    markdownHeadingSnippet = "## Titel",
    markdownBulletSnippet = "- lijstitem",
    markdownNumberedSnippet = "1. lijstitem",
    markdownQuoteSnippet = "> citaat",
    previewToggleEdit = "✏️ Bewerken",
    previewToggleShow = "👁 Voorbeeld",
    contractFooterLabel = "🔒 Uitvoercontract — vergrendeld, automatisch toegevoegd",
    actionErrorOffline = "Mislukt — controleer je verbinding.",
    actionErrorGeneric = "Opslaan mislukt, probeer het opnieuw.",
    unsavedChangesNotice = "● Niet-opgeslagen wijzigingen",
    savingAction = "Opslaan…",
    saveAction = "Wijzigingen opslaan",
)
